import PhotoSwipe from 'photoswipe';
// import PhotoSwipeVideoPlugin from 'photoswipe-video-plugin'

import 'photoswipe/dist/photoswipe.css';
import '../../styles/components/photoswipe.scss'
import trackEvent from '../utils/trackEvent';

export default class ImageZoom {
  constructor(images, options = {}) {
    this.images = images;
    this.options = options;
  }

  open(imageId) {
    document.body.classList.add('scroll-locked');
    let index = 0;

    if (imageId != null) {
      for (let i = 0; i < this.images.length; i++) {
        if (this.images[i].id === imageId) {
          index = i;
          break;
        }
      }
    }

    const options = {
      zoom: false,
      bgOpacity: 1,
      counter: false,
      captionEl: true,
      clickToCloseNonZoomable: false,
      closeOnScroll: false,
      counterEl: false,
      fullscreenEl: false,
      index,
      history: false,
      wheelToZoom: true,
      preloadFirstSlide: false,
      preload: [1, 1],
      closeSVG: `<svg class="pswp__icn svg-icon icon-close " xmlns="http://www.w3.org/2000/svg"><desc>Close Icon</desc><use xlink:href="#reuse-close"/></svg>`,
      arrowPrevSVG: `<svg class="pswp__icn svg-icon icon-arrow-left" xmlns="http://www.w3.org/2000/svg"><desc>Arrow Left Icon</desc><use xlink:href="#reuse-arrow-thin-left"/></svg>`,
      arrowNextSVG: `<svg class="pswp__icn svg-icon icon-arrow-left" xmlns="http://www.w3.org/2000/svg"><desc>Arrow Right Icon</desc><use xlink:href="#reuse-arrow-thin-left"/></svg>`,
    };

    // Initializes and opens PhotoSwipe
    this.photoswipe = new PhotoSwipe({
      pswpModule: PhotoSwipe,
      dataSource: this.images,
      ...options,
    });

    const playPause = (e) => {
      e.preventDefault();
      if (e.currentTarget.paused) {
        e.currentTarget.play();
      } else {
        e.currentTarget.pause();
      }
    }

    const muteUnmute = (e, el) => {
      e.preventDefault();
      const video = this.photoswipe.currSlide.content.element.querySelector('video');
      video.muted = !video.muted;
      if (video.muted) {
        el.classList.add('muted');
        el.title = 'Unmute';
      } else {
        el.classList.remove('muted');
        el.title = 'Mute';
      }
    }

    this.muteUnmuteButton = null;

    this.photoswipe.on('uiRegister', () => {
      this.photoswipe.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
          pswp.on('change', () => {
            let captionHTML = '';
            if (pswp.currSlide.content.type === 'image') {
              if (pswp.hasMouse) {
                captionHTML = 'Scroll to zoom';
              } else {
                captionHTML = 'Double tap to zoom';
              }
            } else if (pswp.currSlide.content.element.querySelector('video')) {
              if (pswp.hasMouse) {
                captionHTML = '<span class="light-text">Click to play/pause</span>';
              } else {
                captionHTML = '<span class="light-text">Tap to play/pause</span>';
              }
            }
            el.innerHTML = captionHTML || '';
          });
        }
      });
      /* this.photoswipe.ui.registerElement({
        name: 'play-pause',
        order: 10,
        isButton: true,
        appendTo: 'bar',
        html: '<button class="pswp__button pswp__button--play-pause" title="Play/Pause">Play Pause</button>',
        onInit: (el, pswp) => {
          el.addEventListener('click', playPause);
          pswp.on('change', () => {
            const video = this.photoswipe.currSlide.content.element.querySelector('video');
            if (video) {
              if (el.classList.contains('paused')) {
                video.pause();
              } else {
                video.play();
              }
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
          });
        }
      }); */
      this.photoswipe.ui.registerElement({
        name: 'mute-unmute',
        order: 11,
        isButton: true,
        appendTo: 'bar',
        html: `<svg class="pswp__icn svg-icon icon-unmute" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#reuse-unmute"></use></svg><svg class="svg-icon icon-mute pswp__icn" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#reuse-mute"></use></svg>`,
        onInit: (el, pswp) => {
          this.muteUnmuteButton = el;
          el.addEventListener('click', (e) => muteUnmute(e, el));
          pswp.on('change', () => {
            const video = this.photoswipe.currSlide.content.element.querySelector('video');
            if (video) {
              el.hidden = false;
              if (video.hasAttribute('muted')) {
                el.classList.add('muted');
                el.title = 'Unmute';
                video.removeAttribute('muted');
              }
              if (el.classList.contains('muted')) {
                video.muted = true;
              } else {
                video.muted = false;
              }
              if (video.muted) {
                el.classList.add('muted');
                el.title = 'Unmute';
              } else {
                el.classList.remove('muted');
                el.title = 'Mute';
              }
            } else {
              el.hidden = true;
            }
          });
        }
      });

      this.photoswipe.ui.registerElement({
        name: 'video-loading',
        order: 12,
        isButton: false,
        appendTo: 'bar',
        html: '<div class="pswp__video-loading"><svg class="pswp__icn svg-icon icon-spinner " xmlns="http://www.w3.org/2000/svg"><desc>Loading Icon</desc><use xlink:href="#reuse-spinner"/></svg></div>',
        onInit: (el, pswp) => {
          pswp.on('change', () => {
            const video = this.photoswipe.currSlide.content.element.querySelector('video');
            if (video && video.readyState < 3) {
              video.addEventListener('canplaythrough', () => {
                el.style.display = 'none';
              });
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
          });
        }
      });

      if (this.options.autoProgress) {
        this.photoswipe.ui.registerElement({
          name: 'auto-progress',
          order: 12,
          isButton: false,
          appendTo: 'root',
          html: '<div class="pswp_progress-bar"><div class="pswp_progress-bar-fill"></div></div>',
          onInit: (el, pswp) => {
            this.progressBar = el.querySelector('.pswp_progress-bar-fill');
            pswp.on('change', () => {
              if (pswp.currSlide.content.type === 'image') {
                el.style.display = 'block';
                el.style.animationDuration = this.options.autoProgress;
              } else {
                el.style.display = 'none';
              }
            });
          }
        });
      }
    });

    this.photoswipe.on('change', () => {
      if (this.photoswipe.currSlide.content.type === 'image') {
        const imageSrc = this.photoswipe.currSlide.data.src;
        const imageIndex = this.photoswipe.currIndex + 1;
        trackEvent('ProductImageView', { imageIndex, imageSrc, productHandle: this.options.productHandle });
      }
      if (this.photoswipe.currSlide.html && ~this.photoswipe.currSlide.html.indexOf('model-viewer')) {
        this.allowSwipe = false;
        this.photoswipe.container.classList.add('model-view');
      } else {
        this.allowSwipe = true;
        this.photoswipe.container.classList.remove('model-view');
      }
    });

    this.photoswipe.on('close', () => {
      this.photoswipe.container.querySelectorAll('video').forEach(v => v.pause());
      document.body.classList.remove('scroll-locked');
    });

    this.photoswipe.on('change', () => {
      this.photoswipe.container.querySelectorAll('video').forEach(v => {
        v.pause()
        v.currentTime = 0;
      });
      const videos = this.photoswipe.currSlide.content.element.querySelectorAll('video');
      videos.forEach(v => {
        v.play().catch(() => {
          console.log('Video autoplay prevented');
          v.muted = true;
          this.muteUnmuteButton.classList.add('muted');
          this.muteUnmuteButton.title = 'Unmute';
          v.play();
        })
      });

      if (videos.length) {
        this.photoswipe.element.classList.add('video-slide');
      } else {
        this.photoswipe.element.classList.remove('video-slide');
      }
    })

    const autoProgress = () => {
      this.photoswipe.container.style.transition = 'all 0.5s ease-in-out';
      this.photoswipe.next();
      this.photoswipe.container.scrollTop;
      this.photoswipe.container.style.transition = '';
    }

    let imageProgressTimeout;

    const videoPlayed = (e) => {
      const video = e.currentTarget;
      if (video.currentTime >= 1) {
        video.removeEventListener('timeupdate', videoPlayed);
        if (this.options.onVideoPlay) {
          this.options.onVideoPlay(video.currentSrc);
        }
      }
    }


    this.photoswipe.on('contentActivate', ({ content }) => {
      const video = content.element.querySelector('video');
      if (video) {
        if (this.options.autoProgress) {
          video.addEventListener('ended', autoProgress);
        }
        video.addEventListener('click', playPause);
        video.addEventListener('timeupdate', videoPlayed);
      } else if (content.type === 'image') {
        if (this.options.autoProgress) {
          imageProgressTimeout = setTimeout(autoProgress, this.options.autoProgress);
          this.photoswipe.on('pointerDown', () => {
            clearTimeout(imageProgressTimeout);
            this.progressBar.style.animationPlayState = 'paused';
          });
        }
      }
    });

    this.photoswipe.on('contentDeactivate', ({ content }) => {
      const video = content.element.querySelector('video');
      if (video) {
        if (this.options.autoProgress) {
          video.removeEventListener('ended', autoProgress);
        }
        video.removeEventListener('click', playPause);
        video.removeEventListener('timeupdate', videoPlayed);
      }
      if (this.options.autoProgress) {
        clearTimeout(imageProgressTimeout);
        this.progressBar.style.animationPlayState = 'running';
        this.photoswipe.off('pointerDown');
      }
    });

    this.photoswipe.init();
  }

  close() {
    if (this.photoswipe) {
      this.photoswipe.close();
    }
  }

  unload() {
    this.close();
  }
}
